import React from 'react';
import { BsWhatsapp } from 'react-icons/bs';
import { FaGithub, FaLinkedin, FaInstagram, } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi"

const SocialLinks = () => {
    const links = [
        {
            id: 1,
            child: (
                <>
                    LinkedIn <FaLinkedin size={25} />
                </>
            ),
            href: "https://www.linkedin.com/in/shafkat-saad/",
            style: "rounded-tr-md",
        },
        {
            id: 2,
            child: (
                <>
                    GitHub <FaGithub size={25} />
                </>
            ),
            href: "https://github.com/sabidalam",
        },
        {
            id: 3,
            child: (
                <>
                    Instagram <FaInstagram size={25} />
                </>
            ),
            href: "https://www.instagram.com/_sporsho___/",
        },
        {
            id: 4,
            child: (
                <>
                    Whatsapp <BsWhatsapp size={25} />
                </>
            ),
            href: "https://api.whatsapp.com/send?phone=01521567825",
        },
        {
            id: 5,
            child: (
                <>
                    Mail <HiOutlineMail size={25} />
                </>
            ),
            href: "mailto:shafkatsaad@gmail.com",
            style: "rounded-br-md",
        },
    ];
    return (
        <div className="hidden lg:flex flex-col top-[35%] left-0 fixed">
            <ul>
                {links.map(({ id, child, href, style }) => (
                    <li
                        key={id}
                        className={
                            "bg-[#070716] flex justify-between items-center w-40 h-14 px-4 ml-[-100px] hover:ml-[-10px] hover:rounded-md duration-300 hover:bg-gray-900" +
                            " " +
                            style
                        }
                    >
                        <a
                            href={href}
                            className="flex justify-between items-center w-full text-white"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {child}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SocialLinks;